/**
 * Sticky Add to Cart Bar
 * Shows/hides sticky bar based on main add to cart button visibility
 */

class StickyAddToCart {
  constructor() {
    this.stickyBar = document.querySelector('[data-sticky-atc-bar]');
    this.mainAtcButton = document.querySelector('[data-product-atc]');
    this.mainQuantityInput = document.querySelector('[data-product-form] input[name="quantity"]');
    this.stickyAtcButton = document.querySelector('[data-sticky-atc-button]');
    this.stickyQtyInput = document.querySelector('[data-sticky-qty-input]');
    this.stickyQtyDecrease = document.querySelector('[data-sticky-qty-decrease]');
    this.stickyQtyIncrease = document.querySelector('[data-sticky-qty-increase]');
    this.mainProductForm = document.querySelector('[data-product-form]');

    if (!this.stickyBar || !this.mainAtcButton) {
      return;
    }

    this.init();
  }

  init() {
    this.setHeaderOffset();
    this.setupIntersectionObserver();
    this.setupQuantityControls();
    this.setupAddToCartButton();
    this.setupVariantListener();
    this.syncInitialQuantity();
  }

  setHeaderOffset() {
    // Find the header and set CSS variable for offset
    const header = document.querySelector('header, [role="banner"], .site-header, #shopify-section-header, .header');
    if (header) {
      const updateHeaderHeight = () => {
        const headerHeight = header.offsetHeight;
        document.documentElement.style.setProperty('--header-height', `${headerHeight}px`);
      };

      // Initial set
      updateHeaderHeight();

      // Use ResizeObserver for better performance and accuracy
      if ('ResizeObserver' in window) {
        const resizeObserver = new ResizeObserver(() => {
          updateHeaderHeight();
        });
        resizeObserver.observe(header);
        this.headerResizeObserver = resizeObserver;
      } else {
        // Fallback to resize event
        window.addEventListener('resize', updateHeaderHeight);
      }

      // Also update on scroll (some headers change height on scroll)
      let scrollTimeout;
      window.addEventListener('scroll', () => {
        clearTimeout(scrollTimeout);
        scrollTimeout = setTimeout(updateHeaderHeight, 100);
      }, { passive: true });
    }
  }

  // setupIntersectionObserver() {
  //   const options = {
  //     root: null,
  //     rootMargin: '0px',
  //     threshold: 0
  //   };

  //   this.observer = new IntersectionObserver((entries) => {
  //     entries.forEach(entry => {
  //       // Get the position of the button relative to viewport
  //       const buttonRect = this.mainAtcButton.getBoundingClientRect();
  //       const scrolledPastButton = buttonRect.top < 0;

  //       if (entry.isIntersecting) {
  //         // Main button is visible, hide sticky bar
  //         this.stickyBar.classList.remove('is-visible');
  //       } else {
  //         // Main button is not visible
  //         // Only show sticky bar if we've scrolled DOWN past it (not if it's below viewport)
  //         if (scrolledPastButton) {
  //           this.stickyBar.classList.add('is-visible');
  //         } else {
  //           this.stickyBar.classList.remove('is-visible');
  //         }
  //       }
  //     });
  //   }, options);

  //   this.observer.observe(this.mainAtcButton);
  // }
setupIntersectionObserver() {
  const sentinel = document.querySelector('[data-atc-sentinel]');
  if (!sentinel) return;

  let lastScrollY = window.scrollY;

  this.observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      const scrollingDown = window.scrollY > lastScrollY;
      lastScrollY = window.scrollY;

      if (!entry.isIntersecting && scrollingDown) {
        // We scrolled PAST the Add to Cart button
        this.stickyBar.classList.add('is-visible');
      } else {
        // Button is visible OR scrolling up
        this.stickyBar.classList.remove('is-visible');
      }
    });
  }, {
    threshold: 0
  });

  this.observer.observe(sentinel);
}

  setupQuantityControls() {
    if (!this.stickyQtyInput) return;

    // Decrease quantity
    this.stickyQtyDecrease?.addEventListener('click', () => {
      const currentValue = parseInt(this.stickyQtyInput.value) || 1;
      if (currentValue > 1) {
        this.stickyQtyInput.value = currentValue - 1;
        this.syncQuantityToMain();
      }
    });

    // Increase quantity
    this.stickyQtyIncrease?.addEventListener('click', () => {
      const currentValue = parseInt(this.stickyQtyInput.value) || 1;
      this.stickyQtyInput.value = currentValue + 1;
      this.syncQuantityToMain();
    });

    // Direct input
    this.stickyQtyInput.addEventListener('change', () => {
      let value = parseInt(this.stickyQtyInput.value) || 1;
      if (value < 1) value = 1;
      this.stickyQtyInput.value = value;
      this.syncQuantityToMain();
    });

    // Sync from main to sticky
    if (this.mainQuantityInput) {
      this.mainQuantityInput.addEventListener('change', () => {
        this.stickyQtyInput.value = this.mainQuantityInput.value;
      });
    }
  }

  syncQuantityToMain() {
    if (this.mainQuantityInput) {
      this.mainQuantityInput.value = this.stickyQtyInput.value;
      // Trigger change event for any listeners
      this.mainQuantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  syncInitialQuantity() {
    if (this.mainQuantityInput && this.stickyQtyInput) {
      this.stickyQtyInput.value = this.mainQuantityInput.value || 1;
    }
  }

  setupAddToCartButton() {
    if (!this.stickyAtcButton) return;

    this.stickyAtcButton.addEventListener('click', (e) => {
      e.preventDefault();

      // Sync quantity before submitting
      this.syncQuantityToMain();

      // Trigger the main form submission
      if (this.mainProductForm) {
        const submitButton = this.mainProductForm.querySelector('button[type="submit"]');
        if (submitButton) {
          submitButton.click();
        }
      } else {
        // Fallback: find and submit the product form
        const productForm = document.querySelector('form[action*="/cart/add"]');
        if (productForm) {
          productForm.querySelector('button[type="submit"]')?.click();
        }
      }
    });
  }

  setupVariantListener() {
    // Listen for variant changes to update price
    document.addEventListener('variant:change', (event) => {
      if (event.detail && event.detail.variant) {
        this.updatePrice(event.detail.variant);
        this.updateAvailability(event.detail.variant);
      }
    });

    // Also listen for the variant selection component
    const variantSelection = document.querySelector('variant-selection');
    if (variantSelection) {
      variantSelection.addEventListener('change', () => {
        // Get the selected variant from the main form
        const variantId = variantSelection.querySelector('[data-variants]')?.value;
        if (variantId && variantId !== 'not-selected') {
          this.fetchVariantData(variantId);
        }
      });
    }
  }

  async fetchVariantData(variantId) {
    try {
      const productUrl = window.location.pathname + '.js';
      const response = await fetch(productUrl);
      const productData = await response.json();
      const variant = productData.variants.find(v => v.id == variantId);

      if (variant) {
        this.updatePrice(variant);
        this.updateAvailability(variant);
      }
    } catch (error) {
      console.error('Error fetching variant data:', error);
    }
  }

  updatePrice(variant) {
    const priceContainer = document.querySelector('[data-sticky-price]');
    if (!priceContainer) return;

    const formatMoney = (cents) => {
      return Shopify.formatMoney(cents, window.theme?.moneyFormat || '${{amount}}');
    };

    if (variant.compare_at_price && variant.compare_at_price > variant.price) {
      priceContainer.innerHTML = `
        <span class="sticky-atc-bar__price--sale">
          ${formatMoney(variant.price)}
        </span>
        <span class="sticky-atc-bar__price--compare">
          ${formatMoney(variant.compare_at_price)}
        </span>
      `;
    } else {
      priceContainer.innerHTML = `
        <span class="sticky-atc-bar__price--regular">
          ${formatMoney(variant.price)}
        </span>
      `;
    }
  }

  updateAvailability(variant) {
    if (!this.stickyAtcButton) return;

    const buttonText = this.stickyAtcButton.querySelector('.sticky-atc-bar__button-text');

    if (variant.available) {
      this.stickyAtcButton.disabled = false;
      if (buttonText) {
        buttonText.textContent = this.stickyAtcButton.dataset.addToCartText || 'Add to Cart';
      }
    } else {
      this.stickyAtcButton.disabled = true;
      if (buttonText) {
        buttonText.textContent = this.stickyAtcButton.dataset.soldOutText || 'Sold Out';
      }
    }
  }

  destroy() {
    if (this.observer) {
      this.observer.disconnect();
    }
    if (this.headerResizeObserver) {
      this.headerResizeObserver.disconnect();
    }
  }
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', () => {
    new StickyAddToCart();
  });
} else {
  new StickyAddToCart();
}
